import * as React from "react"
import { Container, Row, Col } from "react-grid-system"
import styled from "styled-components"
import Button from "../../atoms/buttons/Button"
import { DownloadIcon } from "../../atoms/icons/DownloadIcon"
import { Inset, HorizontalSpacer } from "../../atoms/spacers"
import Body from "../../atoms/typography/Body"
import ColorfulH1 from "../../atoms/typography/ColorfulH1"
import H2 from "../../atoms/typography/H2"
import { ContentfulEntryTypeName } from "../../contentful/entries"
import { CampaignPageModel } from "../../contentful/models"
import ImageSquare from "../../atoms/ImageSquare"

const CampaignHeroStyle = styled.div`
  box-shadow: 0px 2px 6px 0px rgba(119, 119, 119, 0.25);
  background-color: ${({ theme }) => theme.colors.white};
`

const CampaignHeroSection: React.FC<
  Partial<
    Pick<
      CampaignPageModel<ContentfulEntryTypeName>,
      "title" | "image" | "subtitle" | "disclaimer" | "cost" | "color" | "sheet"
    >
  >
> = ({ cost, image, subtitle, title, disclaimer, color, sheet }) => {
  return (
    <CampaignHeroStyle>
      <Container>
        <HorizontalSpacer spacing={2} />
        <Row>
          <Col lg={6}>
            <ImageSquare src={image?.url} />
            <HorizontalSpacer spacing={1} />
          </Col>
          <Col lg={6}>
            <Row direction="column" justify="center" style={{ height: "100%" }}>
              <Col xs="content">
                <ColorfulH1 bold color={color ?? "dark"}>
                  {title}
                </ColorfulH1>
                <HorizontalSpacer spacing={2} />
                <H2>{subtitle}</H2>
                <HorizontalSpacer spacing={1} />
                <Body>{disclaimer}</Body>
                <HorizontalSpacer spacing={2} />
                <H2>{cost}</H2>
                <HorizontalSpacer spacing={2} />
                {sheet && (
                  <Row>
                    <Col xs="content">
                      <Button title="I'm interested!" variant={color} iconLeft={<div />} link="#contact-us" />
                      <HorizontalSpacer spacing={2} />
                    </Col>
                    <Col xs="content">
                      <a href={sheet.url} target="_blank" download>
                        <Button title="Campaign sheet" variant="dark" iconLeft={<DownloadIcon />} />
                      </a>
                    </Col>
                  </Row>
                )}
              </Col>
            </Row>
          </Col>
        </Row>
        <HorizontalSpacer spacing={2} />
      </Container>
    </CampaignHeroStyle>
  )
}

export default CampaignHeroSection
